import { useTranslation } from "@opendash/core";
import { Icon } from "@opendash/icons";
import { Dropdown, Flex, Tooltip, Typography } from "antd";
import { ItemType } from "antd/es/menu/interface";
import React, { useMemo } from "react";
import { useKanbanStates, useTicketData } from "../..";
import { Kanban_State } from "../../../../js/parsegenerated";
import { useSaveTicketState } from "../hooks/useSaveTicketState";

type Props = {
  onSave?: (oldState: Kanban_State, newState: Kanban_State) => void;
  onError?: (error: any) => void;
};

export const StateCircle = (props: Props) => {
  const ticketData = useTicketData();
  const { states } = useKanbanStates();
  const saveTicketState = useSaveTicketState();
  const t = useTranslation();

  const items: ItemType[] = useMemo(
    () =>
      states
        .filter((state) => state.id !== ticketData.state.id)
        .map((state) => ({
          key: state.id,
          label: (
            <Flex gap="small" align="center">
              <Icon icon="fa:solid:dot-circle" color={state?.get("color")} />
              <Typography.Text>{state?.get("label")}</Typography.Text>
            </Flex>
          ),
          color: state.get("color"),
        })),
    [states]
  );

  async function updateState(stateId: string) {
    if (stateId)
      try {
        const state = states.find((state) => state.id === stateId);
        if (!state) throw new Error(t("maintenance:ticket.state.invalid"));
        await saveTicketState(stateId, ticketData.ticket.id);
        props.onSave?.(ticketData.state, state);
      } catch (e) {
        console.error(e);
      }
  }

  return (
    <Dropdown
      menu={{ items, onClick: (info) => updateState(info.key) }}
      trigger={["click"]}
      placement="bottom"
      arrow={{ pointAtCenter: true }}
    >
      <Tooltip title={ticketData.state?.get("label")}>
        <Icon
          icon="fa:solid:dot-circle"
          color={ticketData.state?.get("color")}
          style={{ cursor: "pointer" }}
        />
      </Tooltip>
    </Dropdown>
  );
};
